// removed by extract-text-webpack-plugin
module.exports = {"prueba":"prueba","itemsVideo":"itemsVideo"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Prueba/prueba.scss
// module id = 585
// module chunks = 0